import React from "react";
import { useDispatch, useSelector } from "react-redux";
import ImageGallery from "react-image-gallery";

import { renderGalleryItem, renderLeftNav, renderRightNav } from "./utils";
import { addMobileOrLandscapeClass, getIsMobileLandscape, Show } from "../../lib/utils";
import { isNarrowScreen } from "../../lib/constants";
import { onFloorPlanSlide } from "./actions";
import { getGalleryContent } from "./selectors";
import GalleryNavBar from "./GalleryNavBar";
import { FloorInfo } from "./FloorInfo";
import { CloseGalleryButton } from "./CloseGalleryButton";
import { GalleryAnswers } from "./GalleryAnswers";
import { GalleryStylesWrapper } from "./GalleryInner";
import type { RichModule } from "../../lib/types";

type Props = {
  isMobileLandscape: boolean,
  galleryModule: RichModule,
};

/**
 * Render floorplans - it's more custom gallery than just regular gallery -
 * requires to change the right column depending on the selected floor.
 */
export const FloorplansGallery = ({ isMobileLandscape = false, galleryModule }: Props) => {
  const dispatch = useDispatch();
  const galleryContent = useSelector((state) => getGalleryContent(state, galleryModule));

  const items = galleryContent.map((fp) => ({
    original: fp.image,
    thumbnail: fp.image,
  }));
  return (
    <>
      <div className={addMobileOrLandscapeClass("gallery column")}>
        <Show when={!getIsMobileLandscape()}>
          <GalleryNavBar />
        </Show>

        <GalleryStylesWrapper>
          <ImageGallery
            items={items}
            showPlayButton={false}
            showBullets={!isNarrowScreen || (galleryModule.isFloorplan() && !isMobileLandscape)}
            showNav={!isNarrowScreen}
            showThumbnails={!isNarrowScreen && !isMobileLandscape}
            onSlide={(index) => dispatch(onFloorPlanSlide(index))}
            renderLeftNav={renderLeftNav}
            renderRightNav={renderRightNav}
            renderItem={renderGalleryItem}
          />
        </GalleryStylesWrapper>
      </div>

      <div className={addMobileOrLandscapeClass("right-column column")}>
        <FloorInfo galleryModule={galleryModule} />
        <Show when={!galleryModule.isInChatFloorplan()}>
          <GalleryAnswers />
          <CloseGalleryButton />
        </Show>
      </div>
    </>
  );
};
